(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/pages/landing/page.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/pages/landing/page.js');
"use strict";

var _svs$tickets;
const Button = svs.ui.ReactButton;
const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  PageWrapper
} = svs.ticketsValidate.components;
const branding = (_svs$tickets = svs.tickets) === null || _svs$tickets === void 0 ? void 0 : _svs$tickets.data.templateConfig.branding;
const brandingClass = branding === 'triss' ? 'bg-triss-200' : 'bg-tur-200';
const {
  ContextualAnchor
} = svs.ticketsValidate.components;
const ACCOUNT_INFO_TITLE = 'Spelkonto';
const ACCOUNT_INFO_TEXTS = ['När du vinner på en lott eller ett annat spel hos Svenska Spel sätts dina pengar in på ditt personliga spelkonto. '.concat('Vinsten kan sedan tas ut eller användas för att köpa nya lotter digitalt eller spela andra spel.'), 'Spelkontot behövs för att vi ska kunna säkerställa din identitet och att du är över 18 år gammal, vilket är ett krav för att du ska få spela.'];
const useTrackQRCode = ticketId => {
  const shortName = svs.ticketsValidate.utils.getShortNameByTicketId(ticketId);
  React.useEffect(() => {
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateQRCodeSuccess(shortName);
  }, [shortName]);
  const trackButton = React.useCallback(buttonText => svs.ticketgames.ticketUtility.utils.tracking.trackValidateQRCodeButton(shortName, buttonText), [shortName]);
  return {
    trackButton
  };
};
setGlobal('svs.ticketsValidate.pages.Landing', _ref => {
  let {
    match,
    history,
    doHistroyPush = false
  } = _ref;
  const {
    trackButton
  } = useTrackQRCode(match.params.ticketId);
  const branding = svs.ticketsValidate.utils.getBrandByTicketId(match.params.ticketId);
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const ticketId = match.params.ticketId;
  const validatePath = "".concat(svs.core.data.baseUrl).concat(svs.ticketsValidate.routes.VALIDATE.replace(':ticketId', ticketId));
  const onSubmit = e => {
    var _e$currentTarget;
    const buttonText = e === null || e === void 0 || (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.innerText;
    trackButton(buttonText);
    if (doHistroyPush) {
      history.push(svs.ticketsValidate.routes.VALIDATE.replace(':ticketId', ticketId));
    } else {
      svs.utils.url.navigate(validatePath);
    }
  };
  const onLogin = e => {
    e.preventDefault();
    trackButton(e.currentTarget.innerText);
    svs.components.customer_login.login({
      returnNewCustomer: true,
      returnUrl: validatePath,
      extraParams: {
        validateticketonline: true,
        branding
      }
    });
  };
  const onCustomerRegistration = e => {
    e.preventDefault();
    trackButton(e.currentTarget.innerText);
    svs.components.customer_login.login({
      returnNewCustomer: true,
      returnUrl: validatePath,
      newCustomer: true,
      extraParams: {
        validateticketonline: true,
        branding
      }
    });
  };
  return React.createElement(PageWrapper, {
    className: "".concat(brandingClass, " margin-bottom-3 padding-top-3")
  }, isLoggedIn ? React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 6,
    sm: 12
  }, React.createElement("h1", {
    className: "h1"
  }, "Qr-kod inl\xE4st"), React.createElement("img", {
    alt: "QR-kod p\xE5 baksidan av en lott",
    className: "margin-bottom-2 margin-top-1 qr-code",
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets-validate/qr-ok.png")
  }), React.createElement("p", {
    className: "p"
  }, " Klicka p\xE5 forts\xE4tt f\xF6r att r\xE4tta din lott och l\xF6sa in eventuell vinst. "), React.createElement("div", null, React.createElement(Button, {
    block: true,
    className: "margin-bottom-4",
    focus: true,
    onClick: onSubmit,
    type: "button"
  }, "Forts\xE4tt")))) : React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 6,
    sm: 12
  }, React.createElement("h1", {
    className: "h1"
  }, "Qr-kod inl\xE4st"), React.createElement("img", {
    alt: "QR-kod p\xE5 baksidan av en lott",
    className: "margin-bottom-2 margin-top-1 qr-code",
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets-validate/qr-ok.png")
  }), React.createElement("p", {
    className: "tickets-validate-qr-paragraph"
  }, "F\xF6r att r\xE4tta din lott och l\xF6sa in eventuell vinst beh\xF6ver du ha ett", ' ', React.createElement(ContextualAnchor, {
    texts: ACCOUNT_INFO_TEXTS,
    title: ACCOUNT_INFO_TITLE
  }, "spelkonto"), ' ', "hos Svenska Spel."), React.createElement(Button, {
    block: true,
    focus: true,
    onClick: onLogin,
    type: "button"
  }, "Logga in"), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    onClick: onCustomerRegistration,
    transparent: true,
    type: "button"
  }, "Bli kund"), React.createElement("p", {
    className: "f-italic f-small padding-h-4 padding-top-1"
  }, "Om du inte har ett konto skapar du det enkelt med Bank-ID eller Freja EID"))));
});

 })(window);